/**
 * Bulgarian lev.
 */
export var BGN = {
  code: 'BGN',
  base: 10,
  exponent: 2
};